import { Box } from '@unity/cloud-ui';
import { Accordion, AccordionGroup } from '../accordion';

export const Expandable = (props: { title: string; children: React.ReactNode }) => {
  return (
    <Box>
      <AccordionGroup>
        <Accordion title={props.title}>{props.children}</Accordion>
      </AccordionGroup>
    </Box>
  );
};
